import { save, findList, getDetail, del } from '@/axios/api/promotionActivity'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'

const state = {
  params: {
    remarks: '',
    creator: '',
    date: [],
    utmSource: ''
  },
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  tableData: [],
  tblLoading: false
}
const getters = {
  params: state => state.params,
  pager: state => state.pager,
  tableData: state => state.tableData,
  tblLoading: state => state.tblLoading
}
const mutations = {
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  }
}

const actions = {
  // 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  async getTableListApi ({ commit }, params) {
    try {
      commit(UPDATE_TBL_LOADING, true)
      let { data: res } = await findList(params)
      console.log(res)
      commit(UPDATE_TBL_LOADING, false)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {
      commit(UPDATE_TBL_LOADING, false)
    }
  },
  async saveApi ({commit}, params) {
    try {
      const res = await save(params)
      return res && res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  async deleteApi ({commit}, params) {
    try {
      const res = await del(params)
      return res && res.errorCode === 200
    } catch (e) {
      return false
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/promotionActivity.js